import type { StepsSelectionParamsType } from '@dolcevia/lib/searchParams';
import React, { memo } from 'react';
import { Marker } from 'react-leaflet';
import {
  iconActivity,
  iconAirbnb,
  iconBooking,
  iconGreengo,
  iconTripAdvisor,
} from '../assets/marker';
export const ICON_MARKER_MAP = {
  booking: iconBooking,
  hotel: iconBooking,
  tripadvisor: iconTripAdvisor,
  activity: iconActivity,
  greengo: iconGreengo,
  airbnb: iconAirbnb,
};
const StepSelectionMarkerContent = ({
  stepsSelection,
}: { stepsSelection: StepsSelectionParamsType }) => {
  return stepsSelection?.map((step, index) => {
    return (
      <React.Fragment key={index}>
        {step.habitation?.map((habitation) => (
          <Marker
            icon={ICON_MARKER_MAP[habitation.type]}
            key={habitation.name}
            position={[habitation.lat, habitation.lng]}
          />
        ))}
        {step.interest?.map((interest) => (
          <Marker
            icon={ICON_MARKER_MAP[interest.type]}
            key={interest.name}
            position={[interest.lat, interest.lng]}
          />
        ))}
        {step.activity?.map((activity) => (
          <Marker
            icon={ICON_MARKER_MAP[activity.type]}
            key={activity.name}
            position={[activity.lat, activity.lng]}
          />
        ))}
      </React.Fragment>
    );
  });
};

export const StepSelectionMarker = memo(StepSelectionMarkerContent);
